/*
 * Every glyph on the site, inline.
 *
 * Inline rather than an icon font or a sprite because there are nine of them.
 * A font would be a second network request and a flash of missing glyphs; a
 * package would be a dependency for 3KB of paths.
 *
 * All of them are decorative — they sit beside a label that already says what
 * they mean — so they carry `aria-hidden` and no title.
 */

const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true",
  focusable: "false",
};

export function ArrowRight(props) {
  return (
    <svg {...base} {...props}>
      <path d="M4 12h15M13 6l6 6-6 6" />
    </svg>
  );
}

export function ArrowDown(props) {
  return (
    <svg {...base} {...props}>
      <path d="M12 4v15M6 13l6 6 6-6" />
    </svg>
  );
}

export function ChevronDown(props) {
  return (
    <svg {...base} {...props}>
      <path d="M6 9.5 12 15.5 18 9.5" />
    </svg>
  );
}

export function Check(props) {
  return (
    <svg {...base} {...props}>
      <path d="m5 12.8 4.4 4.4L19 7.6" />
    </svg>
  );
}

export function Close(props) {
  return (
    <svg {...base} {...props}>
      <path d="M6 6l12 12M18 6L6 18" />
    </svg>
  );
}

export function Menu(props) {
  return (
    <svg {...base} {...props}>
      <path d="M4 8h16M4 16h16" />
    </svg>
  );
}

/** The Play Store triangle. Filled, because the badge it stands in for is. */
export function PlayMark(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path d="M4.3 2.5c-.3.3-.5.8-.5 1.4v16.2c0 .6.2 1.1.5 1.4l8.6-8.6v-1.8L4.3 2.5Zm10.1 10.1 2.9 2.9 3.4-1.9c1-.6 1-1.6 0-2.2l-3.4-1.9-2.9 2.9v.2ZM5.3 22.2c.4.1.9 0 1.4-.3l9.1-5.1-2.6-2.6-7.9 8ZM13.2 9.8l2.6-2.6L6.7 2.1c-.5-.3-1-.4-1.4-.3l7.9 8Z" />
    </svg>
  );
}

/** A display on a stand. Used wherever the browser console is the subject. */
export function MonitorMark(props) {
  return (
    <svg {...base} {...props}>
      <rect x="2.5" y="4" width="19" height="13" rx="2" />
      <path d="M9 20.5h6M12 17v3.5" />
    </svg>
  );
}

export function PhoneMark(props) {
  return (
    <svg {...base} {...props}>
      <rect x="6.5" y="2.5" width="11" height="19" rx="2.5" />
      <path d="M10.75 5.5h2.5" />
    </svg>
  );
}
